/**
 * Adds a dynamic hovering popover image to any HTML element with a 'data-popover-image'
 * attribute, and the value is expected to be an image source URL.
 * Example usage: data-popover-image="https://bark.us/wp-content/themes/bark/dist/img/star-badge.png"
 */

export function initPopoverImage() {
	if(navigator.maxTouchPoints > 0 || window.innerWidth < 500) return; // skip init if mobile/tablet touchscreen
	let els = document.querySelectorAll('[data-popover-image]');
	if (els.length && document.body) {
		setupPopoverImagesEls(els);
	}
}

function setupPopoverImagesEls(els) {
	if(!els || typeof els !== 'object') return;

	// Create the hover image element
	const popoverImage = document.createElement("img");
	popoverImage.classList.add('popover-image');
	popoverImage.setAttribute('id', 'popover-image');
	popoverImage.setAttribute('alt', '');
	popoverImage.setAttribute('role', 'presentation');
	document.body.appendChild(popoverImage);
	window.popoverImage = popoverImage;

	Array.from(els).forEach(el => {

		const imageScr = el.getAttribute('data-popover-image');
		el.addEventListener('mouseover', startPopoverImage);
		el.addEventListener('mouseout', stopPopoverImage);
		el.addEventListener('mouseover', function(event) {
			window.popoverImage.setAttribute('src', imageScr);
		});
		el.addEventListener('mouseout', function(event) {
			window.popoverImage.setAttribute('src', '');
		});

		// Create preload link for the image file in the head
		const imagePreload = document.createElement("link");
		imagePreload.classList.add('preload-data-popover-image');
		imagePreload.setAttribute('rel', 'preload');
		imagePreload.setAttribute('as', 'image');
		imagePreload.setAttribute('href', imageScr);
		document.head.appendChild(imagePreload);
	});

}


function startPopoverImage() {
	if(navigator.maxTouchPoints > 0 || window.innerWidth < 500) return; // skip if mobile/tablet touchscreen
	document.addEventListener('mousemove', positionPopoverImage);
	window.popoverImage.classList.add('active');
}

function stopPopoverImage() {
	document.removeEventListener('mousemove', positionPopoverImage);
	window.popoverImage.classList.remove('active');
}

function positionPopoverImage(event) {
	// Note: expects 160x160px image
	let mouseX = event.clientX;
  let mouseY = event.clientY;
	let offsetX = 100; // a little right
	let offsetY = -180; // fully above

	// If the image will be cutoff on the right, offset to the left
	if((mouseX + (offsetX + 160 + 10)) > window.innerWidth) {
		offsetX = -210;
	}

	// If the image will be cutoff at the top, offset to the bottom
	let headerNavOffset = (window.innerWidth > 1096) ? 310 : 270;
	if(mouseY < headerNavOffset) {
		offsetY = 30;
	}

	window.popoverImage.setAttribute('style', `left: ${mouseX + offsetX}px; top: ${mouseY + offsetY}px;`);
}
